<template>
	<div class="logo-wrap">
		<a :href="getRealtorLink">
			<svg class="logo" viewBox="0 0 923.4 324.1" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><path d="m163.9 228.7v-67.9l67.8 67.9zm-19.6 0h-47.8v-135.7h47.8zm19.6-135.1c17.2-.3 32.3-1.1 40.6 11.3 1.4 2.1 2.7 4.5 4.1 6.9-.3-.3 8.6 16.8-2.8 33.3-.3.7-.9 1.5-1.4 2.1-11.7 14.4-29.9 10.3-40.6 11.3v-64.9zm-91.9 158.5h173.4v-180.1h-173.4z"/><path d="m356 150.1c0-8.8-4.8-16.5-12.6-20.2-2.6-1.2-6.9-2.7-17.1-2.7h-18.2v69.7h8.7v-61.6h10.8c5.3 0 8.8.4 12.7 2.5 4 2 6.9 7.1 6.9 12.1 0 4.8-2.7 11.2-10.5 13.4-2.9.9-5.9 1-14.3 1h-2l24.4 32.6h11l-19.3-25.4c12.9-1.7 19.5-11.8 19.5-21.4z"/><path d="m364.6 196.9h39v-8.1h-30.3v-23h29.3v-8.1h-29.3v-22.4h30.3v-8.1h-39z"/><path d="m442.1 127.2-29.7 69.7h9.2l9.9-22.8h30.2l9.8 22.8h9.5l-30-69.7zm16.1 38.8h-23.3l11.8-27.6z"/><path d="m498.5 127.2h-8.8v69.7h36.8v-8.1h-28z"/><path d="m523.6 135.3h15.5v61.6h8.8v-61.6h15.4v-8.1h-39.7z"/><path d="m602.7 126c-17.7 0-36.8 13.9-36.8 36.4 0 19.3 16.8 35.7 36.8 35.7 20.3 0 36.8-16.2 36.8-36s-16.5-36.1-36.8-36.1zm0 64c-15.2 0-28-12.6-28-27.6 0-15.6 12.6-28.3 28-28.3 15.5 0 28.1 12.6 28.1 28s-12.6 27.9-28.1 27.9z"/><path d="m698.6 150.1c0-8.8-4.8-16.5-12.6-20.2-2.6-1.2-6.9-2.7-17.1-2.7h-18.2v69.7h8.7v-61.6h10.8c5.3 0 8.8.4 12.7 2.5 4 2 6.9 7.1 6.9 12.1 0 4.8-2.7 11.2-10.5 13.4-2.9.9-5.9 1-14.3 1h-2l24.4 32.6h11l-19.3-25.4c12.9-1.7 19.5-11.8 19.5-21.4z"/><path d="m711.9 188.7h8.7v8.2h-8.7z"/><path d="m779.2 180.7c-1.5 2.9-6.2 9.6-16.8 9.6-11 0-19.7-8.6-19.7-19.6 0-12.2 10-19.4 19.7-19.4 7.2 0 13.4 3.8 16.8 10.1l.3.5h9.1l-.5-1.3c-5.1-12.5-16.6-17-25.8-17-15.4 0-27.9 12.3-27.9 27.3 0 15.2 12.2 27.1 27.9 27.1 11.5 0 20.1-5.5 25.8-16.5l.7-1.4h-9.2z"/><path d="m843 144.9v7c-6.1-7.4-14.9-8.3-18.7-8.3-17.5 0-27.9 13.8-27.9 27.1 0 15.3 12.2 27.3 27.9 27.3 3.7 0 12.4-.9 18.7-8.3v7.1h8.4v-52h-8.4zm-18.7 45.4c-11.3 0-19.5-8.1-19.5-19.3 0-12.9 9.8-19.7 19.5-19.7 10.5 0 19.1 8.8 19.1 19.6-.1 10.9-8.4 19.4-19.1 19.4z"/><path d="m875.8 138.5c0 5.1-4.1 9.1-9.1 9.1-5.1 0-9.2-4.1-9.2-9.1s4-9.1 9.2-9.1c5.1-.1 9.1 4.1 9.1 9.1zm-16.9 0c0 4.3 3.4 7.9 7.8 7.9 4.3 0 7.8-3.5 7.8-7.9 0-4.3-3.4-7.9-7.8-7.9-4.5 0-7.8 3.6-7.8 7.9zm8.3-5.2c.6 0 3.7 0 3.7 2.8 0 1.1-.5 2.2-1.9 2.5 1.4.4 1.7 1.3 1.7 2.6.1 1.8.1 2 .3 2.4h-1.3c-.2-.3-.3-.6-.3-1.9 0-1.7-.3-2.5-2.7-2.5h-2.6v4.4h-1.3v-10.5h4.4zm-3.1 4.9h2.6c.7 0 2.8 0 2.8-1.9 0-1.7-1.9-1.7-2.6-1.7h-2.9v3.6z"/></g></svg>
			<span class="logo-text" v-html="_translate('ui.logo')"></span>
		</a>
	</div>
</template>

<script>

	export default {

		computed: {

			getRealtorLink: function() {

				var link = "https://www.realtor.ca/";
				return link;

			},

		}

	}

</script>

<style lang="scss">

	$logo-height: $nav-height * .7;

	.logo-wrap {
		display: flex;
		align-items: center;

		a { 

			transform: scale(1);
			transform-origin: center;
			transition: transform .3s ease;
			outline: none;
	
			&:focus,
			&:hover {

				transform: scale(1.1);

			}

		}

	}

	.logo {
		height: $logo-height - 10px;
		width: ($logo-height - 10px) * $logo-ratio;
		margin: 5px;

		@include mq('lap') {
			height: $logo-height;
			width: $logo-height * $logo-ratio;
			margin: 0 1em;
		}

	}

	.logo-text {
		font-size: 0;
		visibility: hidden;

		a { color: $white; }
		
	}

</style>